'use strict';

import ChordDiagram from './chord_diagram';

$(function() {
  // anime score diff
  const keys = [
    'profile-stats-anime-genre-sets',
    'profile-stats-manga-genre-sets',
  ];
  keys.filter(k => $(`#${k}`).length).map(key => new ChordDiagram(key)).map(c => c.renderChordDiagram());
});

